/**
 * MaxButton — «МАКС» в суффиксе поля суммы: подставляет весь доступный остаток.
 * Ставим везде, где остаток известен (баланс счёта, карты, вознаграждения) — чтобы
 * клиент не считал руками. type="button" обязателен: поле обычно внутри <label>/формы.
 */
export function MaxButton({ onClick, disabled = false }: { onClick: () => void; disabled?: boolean }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="text-[12px] font-semibold text-brand active:opacity-70 disabled:opacity-40"
    >
      МАКС
    </button>
  );
}
